const Loader = (props) => {
  return (
    <div className="col-12">
      <div className="trasparente bg-secondary">
        <div className="progress-spinner progress-spinner-active spinner"></div>

      </div>
    </div>
  );
};

export default Loader;
